import styled from 'styled-components';
import { mixins } from '@tidb-community/ui';

export const Container = styled.div`
  ${mixins.responsive()};
  padding-top: 2rem;
  padding-bottom: 2rem;
`;

export const Main = styled.div``;
